module.exports = "../../app/cells/components/modals/not_subscribed_user_modal_cell.rb";